
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agentic-ai",
      function () {
        return require("private-next-pages/agentic-ai.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agentic-ai"])
      });
    }
  